import React from "react";

const Failure = ({ reportID }) => {
  return (
    <div className="text-center mt-40">
      Se ha producido un error. Póngase en contacto con{" "}
      <strong>
        <a href="mailto:info@kidodynamics.com">info@kidodynamics.com</a>
        <br />
        {reportID}
      </strong>
    </div>
  );
};

export default Failure;
